import { Button } from "@/components/ui/button";
import type { ListBox, Read } from "@/components/ui/box.schema";
import type { Announcement, AnnouncementFeed } from "@/lib/api/announcements";
import { inboxWords as words, messageTime } from "./inbox-copy";

export interface NoticeReadMark { failed: boolean; pending: boolean; retry(): void }
export function noticesBox({read,course,onCourseChange,selected,mark,query,onQueryChange}:{
  read:Read<AnnouncementFeed>;course:string;onCourseChange(course:string):void;selected?:string;
  mark(id:string):NoticeReadMark;query:string;onQueryChange(query:string):void;
}):ListBox<AnnouncementFeed,Announcement> {
  const value=read.status==="ready"?read.value:read.status==="stale"?read.last:null;
  const courses=new Map(value?.items.filter(item=>item.course_id).map(item=>[item.course_id!,item.course_title??words.course]));
  if(course && !courses.has(course))courses.set(course,words.selectedCourse);
  const shown=(item:Announcement)=>(!course||item.course_id===course) && (!query.trim()||item.title.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()));
  return {
    id:"notices",kind:"list",label:words.notices,job:words.readNotices,owner:{system:"imam"},fold:"never",readTime:true,
    read:read.status==="ready"&&!read.value.items.length?{status:"empty",sentence:words.noNotices}:read,
    state:()=>({class:"quiet",word:words.latestFirst}),detail:()=>words.institutionAndCourses,
    figures:feed=>[{value:feed.items.length,unit:feed.items.length===1?words.notice:words.noticesUnit}],
    rows:feed=>feed.items.filter(shown),
    find:value?{placeholder:words.findNotice,onQueryChange,facets:[{label:words.course,value:course,
      options:[{value:"",label:words.allCourses},...[...courses].map(([value,label])=>({value,label}))],onChange:onCourseChange}],
      hidden:value.items.filter(item=>!shown(item)).length}:undefined,
    row:{key:item=>item.id,title:item=>item.title,
      state:item=>item.is_urgent?{class:"waiting",word:item.is_read?words.urgent:words.urgentUnread}:!item.is_read?{class:"reading",word:words.unread}:null,
      facts:item=>[words.categories[item.category],item.scope==="academy"?words.academyWide:item.course_title??words.course,messageTime(item.published_at)].join(" · "),
      act:()=>({does:"open",verb:words.open}),startsOpen:item=>item.id===selected,
      detail:item=>{
        const status=mark(item.id);
        return <div className="grid gap-3 py-3">
          <p className="whitespace-pre-wrap break-words text-body">{item.body}</p>
          {status.failed && <div className="grid gap-2" role="status">
            <p className="text-ui text-muted-foreground">{words.markReadFailed}</p>
            <Button variant="ghost" disabled={status.pending} onClick={status.retry}>{words.tryMarkRead}</Button>
          </div>}
        </div>;
      },
    },
  };
}
